import { LoadingState } from "@/components/loading-state";
import { Panel } from "@/components/panel";
import { useFullScan } from "@/sdk/hooks/use-scanner";

export function SimulationPanel() {
  const run = useFullScan();

  return (
    <Panel title="Monte Carlo Simulation">
      <div className="space-y-3">
        <p className="text-xs text-white/45">
          Dedicated Monte Carlo output is not wired yet. This panel currently runs the full scanner as a simulation placeholder.
        </p>
        {/* Presentational-honesty fix, not a capability removal: the old
            bankroll input was a dead control. POST /api/scanner/scan
            (ScanRequest in backend/routers/scanner.py) accepts no bankroll
            field and the route hard-codes bankroll=10000, so the value the
            user typed never left the browser with any effect. */}
        <p className="text-xs text-white/45">
          The scan runs with the server-configured bankroll ($10,000); it cannot be set from this panel.
        </p>
        <button
          type="button"
          onClick={() => run.mutate({})}
          disabled={run.isPending}
          className="rounded bg-blue-600 px-3 py-1.5 text-xs text-white hover:bg-blue-500 disabled:opacity-50"
        >
          {run.isPending ? "Running..." : "Run Simulation"}
        </button>
        {run.isPending ? <LoadingState text="Running simulation..." /> : null}
        {run.isError ? (
          <p className="text-sm text-red-400">
            Simulation scan failed: {run.error instanceof Error ? run.error.message : "request error"}
          </p>
        ) : null}
        {run.data ? (
          <pre className="max-h-60 overflow-auto rounded bg-white/5 p-3 text-xs text-white/60">
            {JSON.stringify(run.data, null, 2)}
          </pre>
        ) : null}
      </div>
    </Panel>
  );
}
